import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BusinessDetailComponent } from './business-detail/business-detail.component';
import { BusinessListComponent } from './business-list/business-list.component';

const routes: Routes = [
  { path: "business", component: BusinessListComponent },
  { path: "business/:id", component: BusinessDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessRoutingModule { }
